const usersRoutes = [
    {
        path: 'list',
        name: 'users-list',
        component: () => import(/* webpackChunkName: "about" */ '../views/users/list.vue'),
    },
    {
        path: 'add',
        name: 'users-add',
        component: () => import(/* webpackChunkName: "about" */ '../views/users/add.vue'),
    },
    {
        path: 'edit/:id',
        name: 'edit-users',
        component: () => import(/* webpackChunkName: "about" */ '../views/users/edit.vue'),
    },
    
];

export default usersRoutes;
